/**
 * @file CanvasCartNotice.tsx
 * @description Строка над канвой на экране «Корзина» и в «Виде корзины»
 * (phase19.16, партия SB120, этап 4; uiux-cart §7): подпись образца
 * («Образец: 3 товара…»); корзину на образце закрыли (×, Esc, конец «окна
 * на 4 с») — «Корзина на образце закрыта» и «Показать снова»; канва не
 * ответила — «Не удалось показать корзину на образце сайта…» с «Повторить».
 * Настройки при этом сохраняются — дело только в показе. Кнопка — под
 * текстом: на 360 текст не сжимается.
 */

import { Eye, RefreshCw } from "lucide-react";

import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";
import { CANVAS_CART_CLOSED_TEXT, CANVAS_CART_FAILED_TEXT, CANVAS_CART_SAMPLE_TEXT } from "../../../lib/site-view/canvas-cart-messages";

interface Props {
  failed: boolean;
  /** Канва ответила, что корзина закрыта. */
  closed: boolean;
  /** Открыть корзину снова (`view: "cart"`). */
  onRetry: () => void;
}

export function CanvasCartNotice({ failed, closed, onRetry }: Props) {
  if (failed) {
    return (
      <NoticeStrip tone="warning" className="shrink-0">
        <span className="block">{CANVAS_CART_FAILED_TEXT}</span>
        <Button variant="outline" className="mt-2 min-h-12 can-hover:min-h-9" onClick={onRetry}>
          <RefreshCw aria-hidden />
          Повторить
        </Button>
      </NoticeStrip>
    );
  }
  if (closed) {
    return (
      <div className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 px-1">
        <span className="type-caption text-on-surface-variant">{CANVAS_CART_CLOSED_TEXT}</span>
        <Button variant="outline" size="sm" className="min-h-12 can-hover:min-h-8" onClick={onRetry}>
          <Eye aria-hidden />
          Показать снова
        </Button>
      </div>
    );
  }
  return <p className="type-caption shrink-0 px-1 text-on-surface-variant">{CANVAS_CART_SAMPLE_TEXT}</p>;
}
